import React, { Component } from 'react';
import Container from './components/common/application_container';
import { getUser } from './actions/session';
import axios from 'axios';
import CustomModal from './components/common/modal'
import { USER_COUNT, ALL_STATS, SYSTEM_STATS } from './config/rest_endpoints';
import AccountStats from './components/MainPage/accountStats';
import CarrierStats from './components/MainPage/carrierStats';
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { RC_LOAD_LOGIN } from './components/routers/RouteConstants';
import { withRouter } from 'react-router-dom';
import SystemStats from './components/MainPage/systemStats';
import DoughnutGraph from './components/common/graphs/doughnut';
import MixState from './components/MainPage/mixStats';
import MultiGraph from './components/MainPage/multiGraph';



class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            totalUser: null,
            userPostpay: null,
            userPrePay: null,
            callCounts: {},
            isLogout: false,
            isExpire: false,
            account_Stats: [],
            carrier_Stats: [],
            system_Stats: [],
            userName:[],
            accountValues:[],
            monetryNames:[],
            monetryValues:[],
            accountsInfo:{}
        }

        this.goLoginPage = this.goLoginPage.bind(this)
    }

    componentWillMount() {
        this.getGraphStats()
        this.userActiveList()

    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.getGraphStats()
        }, 8000)
        this.userActiveList()
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    openLogOutModal() {
        this.setState({ isExpire: true })
    }

    getSystemMonitor() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(SYSTEM_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                let resNames = Object.keys(resp.monetary[0])
                let resValues = Object.values(resp.monetary[0])
                this.setState({
                  monetryNames:resNames,
                  monetryValues:resValues

                })

            }
        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    userActiveList() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(USER_COUNT, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                let resNames = Object.keys(resp)
                let resValues = Object.values(resp)
                this.setState({
                    userName:resNames,
                    accountValues:resValues,
                    accountsInfo:resp
                })
            }

        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    getGraphStats() {
        const { User, system_Stats } = this.state
        var headers = { "Authorization": "Bearer " + User.token };

        axios.get(ALL_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    account_Stats: resp.accounts,
                    carrier_Stats: resp.carriers,
                    system_Stats: resp.system
                })
            }
        }).catch(err => {
            console.log('err :>> ', err);
            var logs = err.response && err.response.status
            console.log('logs :>> ', logs);
            if (logs === 401 || logs === undefined) {
                localStorage.removeItem('user');
                this.setState({ isExpire: true })
            }
        })
    }

    goLoginPage() {
        this.props.history.push(RC_LOAD_LOGIN)
    }


    render() {
        const { totalUser, userPostpay, userPrePay, callCounts, system_Stats, isExpire } = this.state
        var sessionStats = system_Stats.sessions/100;
        var cpsStats = system_Stats.CPS/100
        let logoutModal = {
            details: {
                info: "Session Expired",
                msg:
                    <div style={{textAlign: 'center', padding: '8px 0'}}>
                        <div style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '16px',
                            background: '#FEF2F2',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '16px'
                        }}>
                            <i className="icon-key" style={{fontSize: '24px', color: '#EF4444'}}></i>
                        </div>
                        <h5 style={{fontSize: '16px', fontWeight: '600', color: '#0F172A', margin: '0 0 8px'}}>Session Expired</h5>
                        <p style={{fontSize: '13px', color: '#64748B', margin: '0 0 20px'}}>Your session has expired. Please sign in again to continue.</p>
                        <button
                            type="submit"
                            className="btn"
                            onClick={this.goLoginPage}
                            style={{
                                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '10px 24px',
                                fontSize: '13px',
                                fontWeight: '600',
                                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="icon-key" style={{fontSize: '14px'}}></i>
                            Sign In Again
                        </button>
                    </div>
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeLogOutModal },
            cancelBtn: { label: "Cancel", action: this.closeLogOutModal }
        }

        return (
            <Container title="Home" title1="Dashboard" icon="fa fa-home" >
                <CustomModal
                    visibility={isExpire}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={logoutModal.details}
                    showBtns={false}
                    cancelBtn={logoutModal.cancelBtn}
                    crossBtn={logoutModal.crossBtn}
                />

                {/* Dashboard Stats */}
                <MixState systemStats={this.state.system_Stats} accountStats={this.state.accountsInfo} />

                {/* Revenue Graph */}
                <MultiGraph />

                {/* Account Calls Chart */}
                <div style={{
                    background: '#fff',
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                    marginBottom: '20px',
                    overflow: 'hidden',
                    animation: 'fadeInUp 0.5s ease forwards',
                    animationDelay: '0.25s',
                    opacity: 0
                }}>
                    <div style={{
                        padding: '20px 24px',
                        borderBottom: '1px solid #F1F5F9',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: '#ECFDF5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="icon-phone" style={{fontSize: '14px', color: '#10B981'}}></i>
                        </div>
                        <div>
                            <h4 style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                color: '#0F172A',
                                margin: 0,
                                letterSpacing: '-0.01em'
                            }}>Account Calls</h4>
                            <p style={{fontSize: '12px', color: '#94A3B8', margin: 0}}>Sessions and CPS by account</p>
                        </div>
                    </div>
                    <div style={{padding: '20px'}}>
                        <AccountStats usersStats={this.state.account_Stats} />
                    </div>
                </div>

                {/* Carrier Calls Chart */}
                <div style={{
                    background: '#fff',
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                    marginBottom: '20px',
                    overflow: 'hidden',
                    animation: 'fadeInUp 0.5s ease forwards',
                    animationDelay: '0.3s',
                    opacity: 0
                }}>
                    <div style={{
                        padding: '20px 24px',
                        borderBottom: '1px solid #F1F5F9',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: '#EFF6FF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <i className="icon-drawer3" style={{fontSize: '14px', color: '#3B82F6'}}></i>
                        </div>
                        <div>
                            <h4 style={{
                                fontSize: '15px',
                                fontWeight: '600',
                                color: '#0F172A',
                                margin: 0,
                                letterSpacing: '-0.01em'
                            }}>Carrier Calls</h4>
                            <p style={{fontSize: '12px', color: '#94A3B8', margin: 0}}>Sessions and CPS by carrier</p>
                        </div>
                    </div>
                    <div style={{padding: '20px'}}>
                        <CarrierStats carrier={this.state.carrier_Stats} />
                    </div>
                </div>
            </Container>
        );
    }

}

export default withRouter(App)
